<script setup>
import { onMounted, ref } from "vue"
import { useRoute } from "vue-router";
import axios from "axios"

import PaymentHistoryTable from "@/components/table/PaymentHistoryTable.vue";

const client_information_url = 'client/'


const route = useRoute();
const client_id = route.query.client_id;
const username = ref('');
const email = ref('');
const first_name = ref('');
const last_name = ref('');
const middle_name = ref('');
const phone_number = ref('');
const date_created = ref('');
const date_updated = ref('')


const fetchClientInformation = async () => {
  try{
    const res = await axios.get(client_information_url, {
      params: {
        client_id: client_id,
      }
    });
    if (res.data) {
      const data = res.data;
      username.value = data.username;
      email.value = data.email;
      first_name.value = data.firstname;
      last_name.value = data.lastname;
      middle_name.value = data.middlename;
      phone_number.value = data.phonenumber;
      date_created.value = data.datecreated;
      date_updated.value = data.dateupdated;
    }
  } catch(err){
    console.error(err);
  }
}
// console.log("Client info view client_id: " + client_id)


// Init
onMounted(() => {
  fetchClientInformation()
});
</script>

<template>
  <div class="content">
    <div class="content-wrapper" >
      <!-- Back Button -->

      <div class="d-flex justify-content-start" style="margin-top: 8vh">
        <router-link to="/clients" class="btn btn-outline-dark rounded-pill">
          <i class="fas fa-reply "></i>
        </router-link>
      </div>
      <div class="container">
        <div class="list-group">
          <div class="list-group-item list-group-item-action">
            <div class="col">ФИО:</div>
            <div class="col">{{last_name}} {{ first_name }} {{middle_name}} </div>
          </div>
          <div class="list-group-item list-group-item-action">
            <div class="col">ИИН</div>
            <div class="col">{{ username }}</div>
          </div>
          <div class="list-group-item list-group-item-action">
            <div class="col">Телефон: </div>
            <div class="col">{{ phone_number }}</div>
          </div>
          <div class="list-group-item list-group-item-action">
            <div class="col">Электронная почта (email):</div>
            <div class="col" v-if="email">{{ email }}</div>
            <div class="col" v-else>Не привязана.</div>
          </div>
          <div class="list-group-item list-group-item-action">
            <div class="col">Дата регистрации:</div>
            <div class="col">{{ date_created }}</div>
          </div>
          <div class="list-group-item list-group-item-action">
            <div class="col">Последняя активность: </div>
            <div class="col" v-if="date_updated">{{ date_updated }}</div>
            <div class="col" v-else>Не известно...</div>
          </div>
        </div>
      </div>
      <div class="mt-3">
        <payment-history-table
          :client_id="client_id"
        ></payment-history-table>
      </div>
    </div>
  </div>

</template>

<style scoped>

</style>